"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickTrigger = clickTrigger;
exports.jumpOutTrigger = jumpOutTrigger;
exports.moduleViewTrigger = moduleViewTrigger;
exports.pageViewTrigger = pageViewTrigger;

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function pageViewTrigger(args) {
  window.addEventListener('hashchange', res => {
    const oldURL = (0, _utils.getUrlPathName)(res === null || res === void 0 ? void 0 : res.oldURL);

    if (oldURL === this.url) {
      this.finTrigger({
        type: 'pageViewTrigger',
        params: _objectSpread({
          action: 'leave',
          url: oldURL
        }, args)
      });
    }
  }, false);
}

function jumpOutTrigger() {
  window.addEventListener('visibilitychange', () => {
    // 浏览器切换事件
    if (document.visibilityState === 'hidden') {
      // 状态判断
      this.finTrigger({
        type: 'jumpOutTrigger',
        params: {}
      });
    }
  });
}

function moduleViewTrigger(args) {
  this.finTrigger({
    type: 'moduleViewTrigger',
    params: _objectSpread({}, args)
  });
}

function clickTrigger(args) {
  this.finTrigger({
    type: 'webClickTrigger',
    params: _objectSpread({}, args)
  });
}